import axios from '@/plugins/admin/axios'
import type { Visit } from '../../server/types'
import { auth } from '@/stores/auth'

export const sendPageVisit = async (
  user_id: string,
  page_id: string,
  branch_id: number,
  branch_name: string,
  url: string,
  tracking_session_id: number
) => {
  const response = await axios.post<{ message: string; visit: Visit }>(
    '/api-local/register/visit',
    {
      user_id,
      page_id,
      branch_id,
      branch_name,
      url,
      tracking_session_id
    }
  )

  return response.data
}

export const getVisits = async () => {
  const response = await axios.get<Visit[]>('/api-local/visits')

  return response.data
}

export const sendButtonClick = async (button_id: string, visit_id: number) => {
  const authStore = auth()

  const response = await axios.post('/api-local/register/button-click', {
    user_id: authStore?.user?.name,
    button_id,
    branch_id: authStore?.user?.user_branches?.current_branch_id,
    branch_name: authStore?.user?.user_branches?.current_branch_name,
    visit_id
  })

  return response.data
}

export const getButtonClicks = async () => {
  const response = await axios.get('/api-local/button-clicks')

  return response.data
}

export const getPageActionInsights = async (page_id: string, button_id: string) => {
  const response = await axios.get('/api-local/insights/page-action', {
    params: {
      page_id,
      button_id
    }
  })

  return response.data
}
